/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PulseLoader from "react-spinners/PulseLoader";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { Image } from "hesus-ui-kit";
import Tabs from "./Tabs";
import OrderSummaryHistory from "./OrderSummaryHistory";
import SupplierPlanningHistoryList from "./SupplierPlanningHistoryList";
import historyIcon from "@icons/history.svg";
import historyBlueIcon from "@icons/history-blue.svg";

import {
  GenrealInfo,
  TitleOuter,
  DuplicateLines,
  GridRow,
  GenrealInfoOrder,
  GridSubItem,
} from "./OrderPlanningHistory.styled";
import "../../SupplierList.scss";

const OrderPlanningHistory = (props) => {
  const { t, quoteServiceId, clientOrderId, setRefreshState, planningDate } =
    props;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [tabLoading, setTabLoading] = useState(true);
  const [showHistory, setShowHistory] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const [activeData, setActiveData] = useState([]);

  const historyBtnToggle = () => {
    setShowHistory(!showHistory);
  };

  const toggleTab = (tab) => {
    setTabLoading(true);
    setActiveTab(tab);
  };

  const fetchOrderLinesHistroy = () => {
    axios
      .get(
        `/clientOrders/history?quoteServiceId=${quoteServiceId}&planningDate=${planningDate}`
      )
      .then((response) => {
        setData(response.data?.clientOrderHistory);
        setActiveTab(
          response.data?.clientOrderHistory[0]?.services?.[0]?.clientOrder
            ?.planningDate
        );
        setIsLoading(false);
      })
      .catch((error) => handleApiError(error));
  };

  useEffect(() => {
    fetchOrderLinesHistroy();
  }, []);

  useEffect(() => {
    const selectedOrder = data.find(
      (order) => order.services[0].clientOrder.planningDate === activeTab
    );
    setActiveData(selectedOrder);
    setTabLoading(false);
  }, [activeTab]);

  return (
    <GenrealInfo>
      {isLoading && (
        <div className="suggestions-list-loading">
          <PulseLoader color="#1bace4" size={15} />
        </div>
      )}

      <TitleOuter color={showHistory ? "#474747" : "#00aeea"}>
        <Image
          onClick={historyBtnToggle}
          src={showHistory ? historyIcon : historyBlueIcon}
          alt={
            showHistory
              ? t("ACTION_PLANNING_HIDE_HISTORY")
              : t("ACTION_PLANNING_VIEW_HISTORY")
          }
          title={
            showHistory
              ? t("ACTION_PLANNING_HIDE_HISTORY")
              : t("ACTION_PLANNING_VIEW_HISTORY")
          }
          className="supplier-list__order-planning-icon"
        />
        <DuplicateLines
          onClick={historyBtnToggle}
          rel="noreferrer"
          color={showHistory ? "#474747" : "#00aeea"}
        >
          {showHistory
            ? t("ACTION_PLANNING_HIDE_HISTORY")
            : t("ACTION_PLANNING_VIEW_HISTORY")}
        </DuplicateLines>
      </TitleOuter>
      {!isLoading && showHistory && (
        <>
          <Tabs toggleTab={toggleTab} activeTab={activeTab} orderData={data} />
          {tabLoading && (
            <div className="suggestions-list-loading">
              <PulseLoader color="#1bace4" size={15} />
            </div>
          )}
          {!tabLoading && data?.length > 0 && (
            <GenrealInfoOrder>
              {activeData?.services[0]?.sellingPrice?.enquiryId && (
                <GridRow column="60% 1fr" marginBottom="20px">
                  <OrderSummaryHistory
                    siteId={activeData?.site.id}
                    orderData={activeData?.services[0]}
                    exchangeRates={activeData?.exchangeRates}
                    quoteCurrency={activeData?.quoteCurrency}
                  />
                </GridRow>
              )}

              <SupplierPlanningHistoryList
                planningLines={activeData?.services[0]?.supplierPlanningLines}
                exchangeRates={activeData?.exchangeRates}
                quoteCurrency={activeData?.quoteCurrency}
                serviceItems={activeData?.services[0]?.serviceItems}
                clientOrderId={clientOrderId}
                setRefreshState={setRefreshState}
              />
            </GenrealInfoOrder>
          )}
          {data?.length === 0 && (
            <GenrealInfoOrder padding="0px">
              <GridRow>
                <GridSubItem textAlign="center">{t("NO_DATA")}</GridSubItem>
              </GridRow>
            </GenrealInfoOrder>
          )}
        </>
      )}
    </GenrealInfo>
  );
};
OrderPlanningHistory.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(OrderPlanningHistory);
